import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=05ba5675&scoped=true"
var script = {}
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=05ba5675&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ba5675",
  null
  
)

export default component.exports